import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContestMetaStat } from '@/components/shared/ContestMetaStat';

export interface ContestResultsMetaProps {
  /** Live shows red dot + LIVE; complete shows Complete text only (Figma 10203:56675). */
  variant: 'live' | 'final';
  totalPicks: number;
  points: React.ReactNode;
  rank: React.ReactNode;
  /** Unused: cash “My Prize” is hidden for item-based prizes. */
  myPrize?: React.ReactNode;
  liveLabel: string;
  completeLabel: string;
  /** Optional id suffix for data-test-id */
  testId?: string;
}

/**
 * Shared live / complete contest meta rows — Figma Contest Information
 * Live: 10203:54634 · Complete: 10203:56675
 */
export function ContestResultsMeta({
  variant,
  totalPicks,
  points,
  rank,
  liveLabel,
  completeLabel,
  testId,
}: ContestResultsMetaProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        {variant === 'live' ? (
          <div
            className="flex items-center gap-1 whitespace-nowrap"
            data-test-id={testId ? `live-status-${testId}` : undefined}
          >
            <span className="size-2 shrink-0 rounded-full bg-primary" aria-hidden />
            <span className="font-sans text-label-sm font-semibold text-primary">{liveLabel}</span>
          </div>
        ) : (
          <span
            className="font-sans text-label-sm font-semibold text-primary"
            data-test-id={testId ? `complete-status-${testId}` : undefined}
          >
            {completeLabel}
          </span>
        )}
        <ContestMetaStat label={t('game.labels.numPicks')} value={totalPicks} />
        <ContestMetaStat label={t('game.labels.points')} value={points} />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <ContestMetaStat label={t('game.labels.rank')} value={rank} />
      </div>
    </>
  );
}
